import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const updateModelColorIdIris =
  (prevIri: string, newIri: string) => (model: Model) => {
    const colorIdsByIri = Object.entries(model.modelData.colorIdsByIri).reduce<
      Record<string, string>
    >((acc, [prevColorIri, prevColor]) => {
      const colorIri = prevColorIri === prevIri ? newIri : prevColorIri;
      acc[colorIri] = prevColor;
      return acc;
    }, {});
    setDataProperty<ModelData>(model)(
      model.modelData,
      'colorIdsByIri',
      colorIdsByIri
    );
  };
